// @flow
import React from 'react'
import styled from 'styled-components'
import Colors from 'components/styles/colors'
import { mediaMax } from 'frontend_core/dist/styles/media'
import {
  fontSize,
  spacing,
  borderRadius,
} from 'frontend_core/dist/styles/variables'
import { mediaMin } from 'frontend_core/dist/styles/media'

const Wrapper = styled.div`
  margin-left: 50px;

  &::after {
    display: block;
    clear: both;
    content: '';
  }
  ${mediaMax.phone`
    margin-left: 0;
  `};
`
const Container = styled.div`
  display: table;
  table-layout: fixed;
  float: right;
`
const StatusWrapper = styled.div`
  display: table-cell;
  width: 35px;
  padding-bottom: ${spacing.small_2}px;
  vertical-align: bottom;
`
const Status = styled.span`
  display: inline-block;
  color: ${Colors.gray9};
  font-size: ${fontSize.small}px;
  text-align: right;
  line-height: 1.5;
`
const MessageWrapper = styled.div`
  display: table-cell;
  padding: ${spacing.small_2}px 0 ${spacing.small_2}px ${spacing.small_2}px;
`
const Message = styled.div`
  padding: ${spacing.small_2}px ${spacing.small_3}px;
  vertical-align: bottom;
  line-height: 1.7;
  border-radius: 16px;
  border-bottom-right-radius: ${borderRadius}px;
  background-color: ${Colors.subBgColor};
  white-space: pre-wrap;
  font-size: ${fontSize.small_3}px;
  ${mediaMin.phone`
    padding: ${spacing.medium}px;
  `};
`

type PropTypes = {
  read: boolean,
  time: string,
  messageText: string,
}

export default (props: PropTypes) => (
  <Wrapper>
    <Container>
      <StatusWrapper>
        <Status>
          {props.read ? i18n.t('page.dashboard.reservation.alreadyRead') : ''}
          <br />
          {props.time}
        </Status>
      </StatusWrapper>
      <MessageWrapper>
        <Message dangerouslySetInnerHTML={{ __html: props.messageText }} />
      </MessageWrapper>
    </Container>
  </Wrapper>
)



// WEBPACK FOOTER //
// ./src/components/molecules/message/MessageSelf/index.jsx